// extracted by mini-css-extract-plugin
export default {"categories__header":"Categories_categories__header__JSEIX","categories__count":"Categories_categories__count__NOgMH"};